// Load list texts
export const SL_CARD_TITLE = "si.management.sl.card.title";
export const SL_SECTION_EXISTING_LIST = "si.management.sl.listManagement.title";
export const SL_CARD_MESSAGE_TEXT = "si.management.sl.card.message-text";
export const SL_BACK_BTN_TEXT = "si.common.button.back";
export const SL_LOAD_LIST_HEADER_TEXT_UPLOAD = "si.management.sl.listManagement.header.text";
export const SL_LOAD_LIST_HEADER_TEXT_REPLACE = "si.management.sl.listManagement.header.text.replace";
export const SL_LOAD_LIST_INFO_TEXT_POINT_1 = "si.management.sl.listManagement.body.info.text.point_1";
export const SL_LOAD_LIST_INFO_TEXT_POINT_2 = "si.management.sl.listManagement.body.info.text.point_2";
export const SL_LOAD_LIST_UPLOAD_TEXT = "si.management.sl.listManagement.body.btn.upload.text";
export const SL_LOAD_LIST_UPLOADING_TEXT = "si.management.sl.listManagement.body.btn.upload.loading.text";

export const SL_LOAD_LIST_ASSIGN_NAME_TITLE = "si.management.sl.listManagement.assignList.title";
export const SL_LOAD_LIST_ASSIGN_NAME_SUBTITLE = "si.management.sl.listManagement.assignList.subtitle";
export const SL_LOAD_LIST_ASSIGN_NAME_HERE = "si.management.sl.listManagement.assignList.here";

export const SL_LOAD_LIST_NAME_FIELD_LABEL = "si.management.sl.listManagement.nameField.label";
export const SL_LOAD_LIST_NAME_FIELD_PLACEHOLDER = "si.management.sl.listManagement.nameField.placeholder";
export const SL_LOAD_LIST_NAME_ALREADY_TAKEN_ERROR = "si.management.sl.listManagement.nameField.alreadyTakenError";
export const SL_LOAD_LIST_NAME_IS_TOO_LONG_ERROR = "si.management.sl.listManagement.nameField.tooLongError";

export const SL_UPLOAD_LIST_STEP = "si.management.sl.listManagement.uploadList.label";
export const SL_REVIEW_AND_APPROVE_STEP = "si.management.sl.listManagement.reviewAndApprove.label";

export const SL_CONFIRM_QUIT_MODAL_TITLE = "si.management.sl.listManagement.quitModal.title";
export const SL_CONFIRM_QUIT_MODAL_DETAILS = "si.management.sl.listManagement.quitModal.details";

export const SL_COMMON_CANCEL = "si.common.button.cancel";
export const SL_COMMON_SAVE = "si.common.button.save";
export const SL_COMMON_NO = "si.common.button.no";
export const SL_COMMON_YES = "si.common.button.yes";
